import React from 'react';
import Card from '../../models/card';
import CardItem from '../card-item/card-item';
import Modal from '../modal/modal';

import './card-list.scss';

type Props = { cards: Card[]; handleProgress: (matchedCards: Card[]) => void };
type State = { curPair: Card[]; matchedCards: Card[]; isOpen: boolean; imgUrl: string };

class CardList extends React.Component<Props, State> {
  baseState: State;

  constructor(props: Props) {
    super(props);
    this.handleCard = this.handleCard.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.baseState = this.state = { curPair: [], matchedCards: [], isOpen: false, imgUrl: '' };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.cards !== this.props.cards) {
      this.setState(this.baseState);
    }
  }

  handleCard(card: Card) {
    const curPair = [...this.state.curPair, card];
    var { matchedCards } = this.state;

    if (matchedCards.includes(card) || curPair[0] === curPair[1]) {
      return;
    }

    if (curPair.length === 1) {
      this.setState({ curPair });
    }

    if (curPair.length === 2 && curPair[0].id === curPair[1].id) {
      matchedCards = [...matchedCards, curPair[0], curPair[1]];
      this.setState({ curPair, matchedCards });
      this.resetCurPair();
      this.props.handleProgress(matchedCards);
    }

    if (curPair.length === 2 && curPair[0].id !== curPair[1].id) {
      this.setState({ curPair });
      this.resetCurPair();
      this.props.handleProgress(matchedCards);
    }
  }

  resetCurPair() {
    setTimeout(() => this.setState({ curPair: [] }), 750);
  }

  getFeedback(card: Card): string {
    const { curPair, matchedCards } = this.state;
    return curPair.includes(card) || matchedCards.includes(card) ? 'visible' : 'hidden';
  }

  toggleModal(imgUrl = '') {
    this.setState({ isOpen: !this.state.isOpen, imgUrl });
  }

  render() {
    return (
      <ul className="card-list">
        {this.props.cards.map((card, index) => (
          <CardItem key={index} card={card} feedback={this.getFeedback(card)} handleCard={this.handleCard} toggleModal={this.toggleModal} />
        ))}
        <Modal title="UX-Card details" text="" isText={false} isOpen={this.state.isOpen} toggleModal={this.toggleModal}>
          <a href="https://www.ux-republic.com/nos-offres/" target="_blank" rel="noreferrer noopener">
            <img src={this.state.imgUrl} alt="" />
          </a>
        </Modal>
      </ul>
    );
  }
}

export default CardList;
